import clsx from "clsx";

import type { ReactNode } from "react";

export default function SettingsItemContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "flex border-t border-dotted border-black-300 py-4",
        className,
      )}
    >
      {children}
    </div>
  );
}
